import React, { useEffect } from 'react';
import { AnalyticsProvider } from 'app/scripts/services/analytics-provider';
import loadJSFile from 'utils/load-js-file';

interface Props {
  trackEventName?: string;
  url: string;
}

const TABLEAU_API_URL = `https://eu-west-1a.online.tableau.com/javascripts/api/tableau-2.8.0.min.js`;
const QUERY_PARAMS = `?:embed_code_version=3&:embed=y&:loadOrderID=0&:display_spinner=y&:showAppBanner=false&:display_count=n&:showVizHome=n&:origin=viz_share_link`;

const OPTIONS = {
  hideTabs: true,
  width: '100%',
  height: '100%'
};

let viz: any;

const EmbeddedReport: React.FC<Props> = ({ trackEventName, url }) => {
  useEffect(() => {
    loadJSFile(document.body, TABLEAU_API_URL).then(createViz);

    return () => {
      viz?.dispose();
    };
  }, []);

  function createViz() {
    viz?.dispose();

    if (url) {
      const containerDiv = document.getElementById('vizContainer');
      const finalUrl = `${url}${QUERY_PARAMS}`;
      viz = new window.tableau.Viz(containerDiv, finalUrl, OPTIONS);
    }
  }

  useEffect(() => {
    if (trackEventName) {
      AnalyticsProvider.track(trackEventName);
    }
  }, []);

  return (
    <div className="embedded-report" style={{ height: '1140px' }}>
      <div
        id="vizContainer"
        style={{
          width: '960px',
          height: '2000px',
          margin: '0px auto',
          minHeight: '1px'
        }}
      ></div>
    </div>
  );
};

export default EmbeddedReport;
